import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import getters from './getters'
import mutations from './mutations'
import cableManager from './modules/cableManager'
import clientModule from './modules/client'
import VueCookies from "vue-cookies";
import { TOKEN_COOKIE_EXPIRES } from '@/shared/lib/authCookie'
import { getErrorMessage } from '@/shared/lib/errorMessage'
import { API_BASE, cableUrl } from '@/shared/lib/apiBase'
import { preferredNavMode } from "@/shared/lib/navMode.js";

Vue.use(Vuex)

const state = {
  window_height: window.innerHeight,
  window_width: window.innerWidth,
  table_height: '67vh',
  card_height: '82vh',
  table_full_height: window.innerHeight > 1000 ? '75vh' : '72vh',
  selected: [],
  status: '',
  company_id: null,
  toast_id: null,
  token: VueCookies.get('token') || '',
  work_shift: {},
  user: {},
  state: [],
  active_links: [],
  as_type: [],
  company: [],
  companies: [],
  filterQuery: null,
  tab: 'base1',
  nav_mode: preferredNavMode(),
  // На телефоне меню выезжает поверх страницы по кнопке и не хранит режим:
  // там нет места ни для полосы значков, ни для закреплённого списка.
  nav_drawer: false,
  filter: false,
  moveDialog: false,
  alert: { active: false, message: null, type: null },
  action_cable_connect: false,
  work_shift_connect: false,
  reports_connect: false,
  billing_reports_connect: false,
  action_cable_message: {},
  container: {},
  container_ticket: {},
}

const actions = {
  loginAction ({commit, dispatch}, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      axios.post(API_BASE + '/api/authenticate', user).then(resp => {
        const token = resp.data.auth_token
        commit('auth_success', token)

        Vue.prototype.$cookies.set('token', token, TOKEN_COOKIE_EXPIRES)
        axios.defaults.headers.common['Authorization'] = token

        if (token) {
          Vue.prototype.$cable.connection.connect(cableUrl(token));
          // Подписки на каналы делаются в App.vue через cable/subscribe
          // (watch на token), чтобы избежать двойной подписки при обновлении страницы

          dispatch('current_user')
          dispatch('check_shift')
        }

        resolve(resp)
      }).catch(err => {
        delete axios.defaults.headers.common['Authorization']

        Vue.prototype.$cookies.remove('token')

        commit('auth_error')

        Vue.prototype.$toast.error(getErrorMessage(err));

        reject(err)
      })
    })
  },
  async logout ({ commit, dispatch }) {
    try {
      await axios.post('/api/logout')

      Vue.prototype.$toast.success('Сессия успешно завершена');
    } catch (error) {
      // 401 здесь — норма: сессия уже недействительна, и выход всё равно
      // доводится до конца ниже. Сообщать оператору не о чем.
      const expired = error.response && error.response.status === 401

      if (!expired) Vue.prototype.$toast.error(getErrorMessage(error));
    } finally {
      dispatch('cable/unsubscribeAll', null, { root: true });

      Vue.prototype.$cookies.remove('token')
      Vue.prototype.$cookies.remove('email')
      Vue.prototype.$cookies.remove('user')
      Vue.prototype.$cookies.remove('user_id')

      commit('logout')
      commit('set_user', {})
      commit('close_shift')

      delete axios.defaults.headers.common['Authorization']
    }
  },
  open_shift ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({ url: API_BASE + '/api/work_shifts/open', method: 'POST' })
          .then(resp => {
            const work_shift = resp.data
            Vue.prototype.$cookies.set('work_shift', work_shift)
            commit('open_shift_success', work_shift)
            resolve(resp)
          })
          .catch(err => {
            Vue.prototype.$cookies.remove('work_shift')
            commit('updateAlert', { active: true, message: 'Активная смена уже существует, пожалуйста обновите страничку', type: 'error' })
            reject(err)
          })
    })
  },
  check_shift ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({ url: API_BASE + '/api/work_shifts/active_work_shift', method: 'GET' })
          .then(resp => {
            const work_shift = resp.data
            Vue.prototype.$cookies.set('work_shift', work_shift)
            commit('open_shift_success', work_shift)
            resolve(resp)
          })
          .catch(err => {
            Vue.prototype.$cookies.remove('work_shift')
            commit('updateAlert', { active: true, message: "Смена ещё не начата, чтобы начать работу пожалуйта нажмите 'НАЧАТЬ СМЕНУ'", type: 'info' })
            reject(err)
          })
    })
  },
  current_user ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({ url: API_BASE + '/api/get_current_user', method: 'GET' })
          .then(resp => {
            let user_data = JSON.parse(resp.data.user)
            Vue.prototype.$cookies.set('user_id', user_data.id)
            commit('set_user', user_data)

            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
    })
  },
  close_shift ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({ url: API_BASE + '/api/work_shifts/close', method: 'POST' })
          .then(resp => {
            Vue.prototype.$cookies.remove('work_shift')
            commit('close_shift')
            resolve(resp)
          }).catch(err => {
        commit('updateAlert', { active: true, message: 'Нет активной смены, пожалуйста обновите страничку', type: 'error' })
        reject(err)
      })
    })
  }
}

const store = new Vuex.Store({
  modules: {
    cable: cableManager,
    // Личный кабинет клиента: свой токен и свои данные, к операторскому
    // состоянию не примешивается.
    client: clientModule,
  },
  state,
  getters: getters,
  mutations: mutations,
  actions: actions
})

export default store
